import { gql } from '@apollo/client';

const SIGNOUT = gql`
  mutation Signout {
    me @rest(type: "Signout", method: "DELETE", endpoint: "id", path: "/authentication_token")
  }
`;

export default SIGNOUT;
